import { classes } from '@theme/constants';
import { getAttributeValue } from '@theme/dom';
import { HTMLShopifySectionElement } from '@theme/html-custom-element';
// eslint-disable-next-line import/no-unresolved
import Swiper from 'swiper';

class CollectionCarousel extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (!this.refs.slider) return;

    this.swiper = new Swiper(this.refs.slider, {
      autoplay: getAttributeValue(this, 'autoplay', false)
        ? {
            delay: getAttributeValue(this, 'autoplay-delay', 5000),
          }
        : false,
      effect: 'fade',
      loop: true,
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      speed: 800,
      on: {
        autoplayTimeLeft: (({
          autoplay: { timeLeft },
          params: {
            autoplay: { delay },
          },
        }) => {
          this.style.setProperty('--progress', `${((1 - timeLeft / delay) * 100).toFixed(1)}%`);
        }).bind(this),

        autoplayPause: (({ autoplay: { paused } }) => {
          requestAnimationFrame(() => {
            if (!this.transitioning && paused && this.refs.pause) {
              this.refs.pause.classList.add(classes.active);
            }
          });
        }).bind(this),

        autoplayResume: (() => {
          if (this.refs.pause) {
            this.refs.pause.classList.remove(classes.active);
          }
        }).bind(this),

        beforeTransitionStart: (() => {
          this.transitioning = true;
        }).bind(this),

        slideChangeTransitionEnd: (() => {
          this.transitioning = false;
        }).bind(this),

        slideChange: (({ realIndex }) => {
          this.handleActiveSlide(realIndex);
        }).bind(this),
      },
    });

    this.initializeSwiper();

    this.on('click', this.refs.pause, () => {
      if (this.swiper.autoplay.paused) {
        this.swiper.autoplay.resume();
        return;
      }

      this.swiper.autoplay.pause();
    });
  }

  /**
   * Initializes the swiper instance.
   */
  initializeSwiper() {
    if (this.swiper.autoplay.running) {
      this.classList.add(classes.playing);
    }

    this.handleActiveSlide(this.swiper.realIndex);
  }

  /**
   * Handles the active slide change.
   * @param {number} index0 - The active slide index0.
   */
  handleActiveSlide(index0) {
    if (this.refs.progress) {
      for (const progress of this.refs.progress.all) {
        progress.classList.toggle(classes.active, Number(progress.dataset.index0) === index0);
      }
    }
  }

  onSectionLoad(event) {
    if (event.target.contains(this)) {
      this.initializeSwiper();
    }
  }

  onBlockSelect(event) {
    if (this.contains(event.target)) {
      this.swiper.slideToLoop(Number(event.target.closest('.swiper-slide').dataset.index0), 0);

      if (this.swiper.autoplay.running) {
        this.swiper.autoplay.pause();
      }
    }
  }

  onBlockDeselect(event) {
    if (this.contains(event.target) && this.swiper.autoplay.running) {
      this.swiper.autoplay.resume();
    }
  }
}

if (!customElements.get('collection-carousel')) customElements.define('collection-carousel', CollectionCarousel);
